import React from "react";
import { List } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import styles from "./notification-panel.module.css";
import { CloseOutlined } from "@ant-design/icons";
export default function NotificationPanel({
  notifications,
  fetchNotifications,
  hasMore,
  onClose,
}) {
  return (
    <div id="scrollableDiv" className={styles.notification_container}>
      <div className={styles.notification_header}>
        <div className={styles.header_title_text}>Notifications</div>
        <div className={styles.icon_close}>
          <CloseOutlined onClick={onClose} />
        </div>
      </div>

      <InfiniteScroll
        dataLength={notifications.length}
        next={fetchNotifications}
        hasMore={hasMore}
        loader={<p style={{ textAlign: "center" }}>Loading...</p>}
        scrollableTarget="scrollableDiv"
      >
        <List
          itemLayout="vertical"
          dataSource={notifications}
          locale={{ emptyText: "No notifications" }}
          renderItem={(item) => (
            <List.Item
              className={`${styles.notification_title} ${
                item.is_read ? styles.read_message : styles.unread_message
              }`}
            >
              <List.Item.Meta
                title={item.title || "Notification Title"}
                description={item.message || "Notification Description"}
              />
            </List.Item>
          )}
        />
      </InfiniteScroll>
    </div>
  );
}
